var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{model:{value:(_vm.option.value),callback:function ($$v) {_vm.$set(_vm.option, "value", $$v)},expression:"option.value"}},_vm._l((_vm.option.items),function(item){return _c('el-option',{key:item.id,attrs:{"value":item.id,"label":item.content.text}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }